import React, { useEffect, useState } from 'react'
import ManagedInOdooNotice from '../components/ManagedInOdooNotice'
import { apiDriverApp } from '../../../../libs/apiDriverApp'

export const DailyShifts = () => {
  const [shifts, setShifts] = useState(null);
  const [search, setSearch] = useState("");

  const getShifts = async () => {
    const { data } = await apiDriverApp.get('api/hr/shifts/');
    setShifts(data)
  }

  useEffect(() => {
    getShifts()
  }, [])

  const formatTime = (hour) => {
    const totalMinutes = Math.round(hour * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const filteredShifts = shifts && shifts.filter((shift) => {
    const matchesSearch = shift.name
      .toLowerCase()
      .includes(search.toLowerCase());
    return matchesSearch;
  });

  return (
    <div className="container w-75">
      {/* Título y botón */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Driver Shifts</h3>
      </div>

      <ManagedInOdooNotice what="Driver shifts" />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="w-50">
          <input
            placeholder="Search..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

        </div>
      </div>

      {/* Tabla */}
      <table className="table table-bordered">
        <thead className="bg-secondary text-white text-center">
          <tr>
            <th style={{ width: '10%' }}></th>
            <th style={{ width: '45%' }}>Time</th>
            <th style={{ width: '45%' }}>Title</th>
          </tr>
        </thead>
        <tbody>
          {
            filteredShifts ? filteredShifts.map(item => (
              <tr key={item.id}>
                <td>
                  <div style={{ width: '15px', height: '15px', backgroundColor: item.color }}></div>
                </td>
                <td className="text-center align-middle">{`${formatTime(item.hour_from)} - ${formatTime(item.hour_to)}`}</td>
                <td className="text-center align-middle">{item.name}</td>
              </tr>

            )) : (
              <tr>
                <td colSpan="3" className="text-center align-middle">
                  <div>No Data</div>
                </td>
              </tr>
            )
          }

        </tbody>
      </table>

    </div>


  )
}
